var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stage_4:_Rapport",
    "data-name": "Stage 4: Rapport",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 48.684,
    viewBox: "0 0 50 48.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1728",
    "data-name": "Rectangle 1728",
    width: 33.901,
    height: 21.169,
    fill: "#eff3fa"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_683",
    "data-name": "Ellipse 683",
    cx: 25,
    cy: 24.342,
    rx: 25,
    ry: 24.342,
    fill: "#ee3d4b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32057",
    "data-name": "Group 32057",
    transform: "translate(13.133 16.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32056",
    "data-name": "Group 32056",
    transform: "translate(-5.188 -3.24)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13522",
    "data-name": "Path 13522",
    d: "M17.623,6.14a5.565,5.565,0,0,0-2.63,1.61c-2.038,1.358-3.323.776-3.792.46a2.874,2.874,0,0,1-.282-3.783.765.765,0,0,1,.088-.152c.376-.517.646-.9.873-1.206H7.234a.979.979,0,0,1-.964-.826,2.343,2.343,0,0,0-.248-.686,2.239,2.239,0,0,0-1.3-1.02A17.45,17.45,0,0,0,.218,0L0,.259V12.418l.254.257H1.807a2.123,2.123,0,0,0,1.3-.428,2.552,2.552,0,0,0,.676-.776A.967.967,0,0,1,4.521,11h.094a.969.969,0,0,1,.727.327A72.717,72.717,0,0,0,16.4,21.013a.734.734,0,0,0,.967-.054c.043-.045.043-.1.073-.145l-4.3-4.32a.979.979,0,0,1,1.39-1.375l4.673,4.7a1.026,1.026,0,0,0,.291.107,1.352,1.352,0,0,0,.86-.3A.919.919,0,0,0,20.5,19.3l-4.288-4.311a.975.975,0,1,1,1.332-1.424.6.6,0,0,1,.049.049l4.6,4.63a1.094,1.094,0,0,0,1.281-.188,1.021,1.021,0,0,0,.16-.413L19.2,13.177a.975.975,0,1,1,1.332-1.424.6.6,0,0,1,.049.049l4.673,4.7a1.19,1.19,0,0,0,1.082-.224.966.966,0,0,0,.282-.7.887.887,0,0,0-.054-.252c-.958-.99-7.643-7.859-8.945-9.2",
    transform: "translate(0 0)",
    fill: "#eff3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13523",
    "data-name": "Path 13523",
    d: "M27.921.94a20.308,20.308,0,0,0-5.162.528,2.047,2.047,0,0,0-1.33,1.054,1.952,1.952,0,0,0-.2.545.98.98,0,0,1-1.133.8.97.97,0,0,1-.192-.054L12.672.923a1.948,1.948,0,0,0-1.21-.085A7.394,7.394,0,0,0,8.883,2.167a13.872,13.872,0,0,0-2.014,2.5,1.746,1.746,0,0,0-.3,1.245,1.61,1.61,0,0,0,1.42-.348A6.688,6.688,0,0,1,12.005,3.47h.015a1.392,1.392,0,0,1,1.026.394c5.951,6.118,8.113,8.342,8.909,9.157a2.865,2.865,0,0,0,.765-.686.914.914,0,0,1,.826-.376.989.989,0,0,1,.783.473,2.435,2.435,0,0,0,.642.708,2.186,2.186,0,0,0,1.24.393h1.679l.254-.257V1.118L28.026.979A.158.158,0,0,0,27.915.94",
    transform: "translate(5.757 0.685)",
    fill: "#eff3fa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage4);
export default __webpack_public_path__ + "static/media/stage4.7ac6dea8fa156854c67aa96706ac0877.svg";
export { ForwardRef as ReactComponent };